
export class SceneryAction {
    Id?: number;
    Name = '';
    Description = '';
    StepId: number;
    CommandId?: number;
    WaitMs?: number;
    SettingId?: number;
    SettingValue?: number;
}
